const IMAGE_ASSET_PATH_PREFIX = 'waysprite-image://';

const inMemoryImageAssets = new Map<string, string>();

export const createLevelDesignImageAssetPath = (assetId: string): string =>
  `${IMAGE_ASSET_PATH_PREFIX}${assetId}`;

export const parseLevelDesignImageAssetPath = (value: string): string | null => {
  if (!value.startsWith(IMAGE_ASSET_PATH_PREFIX)) {
    return null;
  }
  const assetId = value.slice(IMAGE_ASSET_PATH_PREFIX.length).trim();
  return assetId.length > 0 ? assetId : null;
};

export const persistLevelDesignImageAsset = (assetId: string, imagePath: string): void => {
  if (!assetId.trim() || !imagePath.trim()) {
    return;
  }
  inMemoryImageAssets.set(assetId, imagePath);
};

export const readLevelDesignImageAsset = (assetId: string): string | null => {
  return inMemoryImageAssets.get(assetId) ?? null;
};

export const deleteLevelDesignImageAssets = (designId: string): void => {
  const trimmedDesignId = designId.trim();
  if (!trimmedDesignId) {
    return;
  }
  const designPrefix = `${trimmedDesignId}:`;

  for (const assetId of [...inMemoryImageAssets.keys()]) {
    if (assetId.startsWith(designPrefix)) {
      inMemoryImageAssets.delete(assetId);
    }
  }
};
